import AppDataService from "./AppDataService";

const COMMON_BASE = 'User'

export default class UserDataService {
    static async getProfile(){
        return await AppDataService.get(`${COMMON_BASE}/GetProfile`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async changePassword(data) {
        return await AppDataService.put(`${COMMON_BASE}/ChangePassword`, data)
    }

    static async updateProfile(data) {
        return await AppDataService.put(`${COMMON_BASE}/Update`, data)
    }
    
    static async getActivityLogs(params) {
        return await AppDataService.post(`${COMMON_BASE}/GetLogs`,  params )
    }

    static async getActivityLogsExcel(params) {
        return await AppDataService.get(`${COMMON_BASE}/ExportUserLogToExcel`,  { params } )
    }

    static async getActivityLogDetails(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetLogData`, { params })
    }

    static async getQRCode() {
        return await AppDataService.get(`${COMMON_BASE}/GetTFAQrImage`)
    }

    static async verifyTFACode(data) {
        return await AppDataService.post(`${COMMON_BASE}/TFAVerifyCode?verificationCode=${data}`)
    }

    static async DisableTFA() {
        return await AppDataService.delete(`${COMMON_BASE}/DisableTFA`)
    }

}